import { AlgoliaProductHit } from '@jbhi-fi/apis/src/algolia/types/AlgoliaProductHit';
import PriceTag from '@jbhi-fi/lanyard-ui/components/PriceTag';
import { getDeliveryTag } from '@jbhi-fi/utils/src/getDeliveryTag/getDeliveryTag';
import React from 'react';

type HitPriceTagProps = {
  hit: AlgoliaProductHit;
  className?: string;
  variant?: 'default' | 'small' | 'extraSmall' | 'floatingCta';
  showDelivery?: boolean;
  showEA?: boolean;
};

export const HitPriceTag = ({ hit, className, variant = 'small', showDelivery, showEA }: HitPriceTagProps) => {
  const displayWasPrice = hit.pricing.displayWasPrice;
  const isCashback = hit.pricing?.displayPriceAfterCashback;
  const disclaimers = window.Jbhifi?.disclaimers ?? [];
  const deliveryTag = showDelivery ? getDeliveryTag(hit.deliveryTag, hit.product?.freightPrice) : undefined;

  let ticketPrice = 0;
  let actualPrice = hit.pricing.displayPriceInc;

  if (isCashback) {
    ticketPrice = hit.pricing.displayPriceInc;
    actualPrice = hit.pricing.priceAfterCashback ?? 0;
  } else if (displayWasPrice) {
    ticketPrice = hit.pricing?.wasPrice ?? 0;
  }

  return (
    <PriceTag
      className={className}
      variant={variant}
      ticket={ticketPrice}
      actual={actualPrice}
      cashback={isCashback}
      toolTips={disclaimers}
      bannerLabel={hit.priceBannerTag?.label}
      showOnHover={false}
      deliveryTag={deliveryTag}
      showEach={showEA}
    />
  );
};
